import {
    Button, Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const ScoreButtonsContainer = styled(Box)(() => ({
    display: 'flex',
    width: '100%',
    marginTop: '12px',
    marginBottom: '12px',
    gap: '4px',
}));

const ScoreButton = styled(Button)(({ variant }) => ({
    ...(variant === 'outlined' && {
        backgroundColor: 'white',
        color: '#000000',
        '&:hover': {
            backgroundColor: '#f5f5f5',
        },
    }),
}));

enum RelevanceScore {
    NotScored = 'NotScored',
    NotRelevant = 'NotRelevant',
    Relevant = 'Relevant',
    HighlyRelevant = 'HighlyRelevant',
}

interface PropTypes {
    entity: Models.IngestConfigApi.RelevanceTests.ScoredEntity;
    onScoreChange: (
        entity: Models.IngestConfigApi.RelevanceTests.ScoredEntity,
        score: Models.IngestConfigApi.RelevanceTests.RelevanceScore
    ) => void;
    markChanged?: () => void;
}

function getButtonColor(score: RelevanceScore): 'success' | 'warning' | 'error' {
    if (score === RelevanceScore.HighlyRelevant) {
        return 'success';
    }
    if (score === RelevanceScore.Relevant) {
        return 'warning';
    }
    return 'error';
}

function getScoreLabel(score: RelevanceScore): string {
    switch (score) {
        case RelevanceScore.HighlyRelevant:
            return 'Highly Relevant';
        case RelevanceScore.NotRelevant:
            return 'Not Relevant';
        default:
            return score;
    }
}

export const ScoreControls = (props: PropTypes): JSX.Element | null => {
    const {
        entity,
        onScoreChange,
        markChanged,
    } = props;

    const validRelevanceScores = [
        RelevanceScore.HighlyRelevant,
        RelevanceScore.Relevant,
        RelevanceScore.NotRelevant,
    ];

    return (
        <ScoreButtonsContainer>
            {validRelevanceScores.map((score): JSX.Element => (
                <ScoreButton
                    fullWidth
                    color={getButtonColor(score)}
                    key={`${entity.designConceptId}_${score}`}
                    size="small"
                    sx={{
                        textTransform: 'none',
                        fontWeight: entity.relevance === score ? 'bold' : 'normal',
                    }}
                    variant={entity.relevance === score ? 'contained' : 'outlined'}
                    onClick={(): void => {
                        onScoreChange(entity, score);
                        if (markChanged) markChanged();
                    }}
                >
                    {getScoreLabel(score)}
                </ScoreButton>
            ))}
        </ScoreButtonsContainer>
    );
};
